import { render, staticRenderFns } from "./OtherConfigurations.vue?vue&type=template&id=2e31567d&scoped=true&"
import script from "./OtherConfigurations.vue?vue&type=script&lang=js&"
export * from "./OtherConfigurations.vue?vue&type=script&lang=js&"
import style0 from "./OtherConfigurations.vue?vue&type=style&index=0&id=2e31567d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e31567d",
  null
  
)

export default component.exports